import React from "react";
// image
import timg1 from "../../images/home-intro01.png";
import timg2 from "../../images/home-intro02.png";
import timg3 from "../../images/home-intro03.png";
import timg4 from "../../images/home-intro04.png";

const PartnerSectionS3 = () => {
  const Teams = [
    {
      id: "1",
      title: "희소금속 Metal제조",
      subtitle: "4N5급인듐(In), 갈륨(Ga) Metal",
      slug: "ISO-9001-1",
      timg: timg1,
    },
    {
      id: "2",
      title: "비철금속 Metal제조",
      subtitle: "3N급 구리(Cu) Pellet / 단광 / Powder",
      slug: "ISO-9001-2",
      timg: timg2,
    },
    {
      id: "3",
      title: "유가금속 Metal제조",
      subtitle: "3N급 은(Silver Beads)",
      slug: "ISO-14001-1",
      timg: timg3,
    },
    {
      id: "4",
      title: "비철금속 Oxide제조",
      subtitle: "구리(Cu),나켈(Ni), 코발트(Co) Hydroxide & Oxide",
      slug: "ISO-14001-2",
      timg: timg4,
    },
  ];

  return (
    <section className="partners-section-s2 " style={{ padding: "120px 0px" }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12">
            <div
              className="title scroll-text-animation"
              data-animation="fade_from_bottom"
              style={{ fontWeight: "700" }}
            >
              <h2 style={{ fontWeight: "700" }}>
                <span style={{ fontWeight: "700" }}>
                  ㈜엠알메탈로는 폐수, 폐기물에서 자11원화를 실현하는
                  종합환경전문기업 입니다.
                </span>
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          {Teams.map((team, titem) => (
            <div
              className="col-lg-3 col-md-6 col-6 fade_bottom"
              key={titem}
              style={{ paddingTop: window.innerWidth > 780 ? "" : "10px" }}
            >
              <div className="team-card">
                <div className="image">
                  <img src={team.timg} alt="" />
                  <img src={team.timg} alt="" />
                </div>
                <div className="text">
                  <h2>
                    <a>{team.title}</a>
                  </h2>
                  <span>{team.subtitle}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSectionS3;
